import {
  Checkbox,
  FormControlLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme
} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useStyle } from "../style";

const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyle();
  const {data, setData,code, setCode, setPostData, reset} = props
  const [itemData, setItemData] = useState(null)
  const[active, setActive] = useState(null)
  const [qty, setQty] = useState('')
  const dispatch = useDispatch()
  const [selectedRows, setSelectedRows] = useState([]);
  const [sumOutstanding, setSumOutstanding] = useState(0);
  const [sumRetQty, setSumRetQty] = useState(0);
  const[resultValue , setResultValue ] = useState(0)
  const [sumDifference, setSumDifference] = useState(0);
  const [search, setSearch] = useState('')
  const [editedQuantities, setEditedQuantities] = useState(new Array(data.length).fill(''));
  // const [rateData, setRateData] = useState({
  //   mrp : '',
  //   disc :'',
  //   rate :'',
  //   gst : '',
  // })
  
  const [editingIndex, setEditingIndex] = useState(null);
  // const [editedValues, setEditedValues] = useState({
  //   qty: "",
  // });
  const codeRef = useRef(null)
  const qtyRef = useRef(null)

  const priceRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
  }


function getSelectedRow(e){
  console.log(e)
  setActive(e)
  const arr=[...data]
} 


 function addToData(){
console.log(data)
codeRef.current.focus()
 }
 function handleQtyChange(e) {
  const inputValue = e.target.value.trim(); // Trim to remove leading and trailing whitespaces
  if (inputValue === '') {
    // If the input is empty, clear the input field
    setData(data.map((item, index) => {
      if (index === active) {
        return { ...item, retQty: '' };
      }
      return item;
    }));
    setSumDifference(data[active].outstanding);
  } else {
    const parsedValue = parseInt(inputValue);
    if (!isNaN(parsedValue)) { // Check if the entered value is a valid number
      const newQty = Math.min(parsedValue, data[active].outstanding); // Ensure the entered quantity does not exceed the outstanding amount
      const updatedData = data.map((item, index) => {
        if (index === active) {
          return { ...item, retQty: newQty };
        }
        return item;
      });
      setData(updatedData);
      setSumDifference(data[active].outstanding - newQty);
    } else {
      // Handle invalid input (e.g., show an error message)
      // Optionally, you can reset the input field to its previous value or set it to 0
      console.log("Invalid input");
    }
  }
}

const handleCheckboxClick = (val ) => {
  console.log(val);
  const isSelected = selectedRows.some((selectedRow) => selectedRow.id === val.id);
  const updatedRows = isSelected
  ? selectedRows.filter((selectedRow) => selectedRow.id !== val.id)
  : [...selectedRows, val];
setSelectedRows(updatedRows);

const sumOutstanding = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.outstanding), 0);
    const sumRetQty = updatedRows.reduce((acc, selectedRow) => acc + parseFloat(selectedRow.retQty || 0), 0);

    // Calculate the difference and store it in the state
    const difference = sumOutstanding - sumRetQty;
    setSumDifference(difference);
    setSumRetQty(sumRetQty);
};

function handleSearch(e){
const value = e.target.value
setSearch(value)
}

useEffect(() => {
  if (data.length > 0) {
    const totalOutstanding = data.reduce((acc, val) => acc + parseFloat(val.outstanding), 0);
    const totalRetQty = data.reduce((acc, val) => acc + parseFloat(val.retQty || 0), 0);
    const result = totalOutstanding - totalRetQty;
    setSumOutstanding(totalOutstanding);
    setSumRetQty(totalRetQty);
    setResultValue(result)
    console.log("Result:", result);
  }
}, [data]);
useEffect(() => {
  if(data.length > 0){
    let arr = []
    data.filter(value=>value.retQty > 0).map(val => {
      const obj = {
        invoice_no: val.docno,
        date: moment(val.docdate).format("YYYY-MM-DD"),
        amount: val.retQty,
        pending_amount:parseFloat(sumDifference).toFixed(2),
        company_id: 1
      }
      arr.push(obj)
    }) 
  setPostData((prevState) => ({...prevState , receipt_details : arr,outstanding:resultValue,}))
  }
},[data,resultValue,sumRetQty,sumDifference])
return (
    <Grid className="w-full h-full">
      <Grid className="flex justify-end pb-2">
        <TextField size="small" placeholder="Search Bill" onChange={handleSearch} disabled={data.length === 0} />
      </Grid>
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Bill No</TableCell>
              <TableCell className={classes.tblCell}>Bill Date</TableCell>
              <TableCell className={classes.tblCell}>Bill Amount</TableCell>
              <TableCell className={classes.tblCell}>OutStanding</TableCell>
              <TableCell className={classes.tblCell}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? _.filter(data,value=>value.docno.toLowerCase().includes(search.toLowerCase())).map( (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}><FormControlLabel label={idx+1} control={<Checkbox disabled={!val.retQty} defaultChecked onClick={() => handleCheckboxClick(val )}/>} /></TableCell>   
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}} >{val.docno}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.docdate}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.amount}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.outstanding}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
               <TextField
                      // size="small"
                      // name="qty"
                      // value={editedQuantities[idx]}
                      // onChange={(e) => handleQtyChange(e.target.value, idx)}  
                      // autoComplete="off"
                      size="small"
                inputRef={qtyRef}
                value={val.retQty}
                onChange={handleQtyChange}
                    />
               </TableCell>
             </TableRow>
            )) : 
            
            <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell padding="checkbox" className={classes.tblContentCell}></TableCell>
             <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
          </TableRow>
            }
              
          </TableBody>
        </Table>
      </TableContainer>
     
    </Grid>
  );
});

export default memo(BillingTable);
